import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber7Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNumber7Square"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.82422 7.78906V9.44727H12.9609V9.55273L9.45117 16.25H11.7012L15.1172 9.45312V7.78906H8.82422Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber7Square;
